var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organization && _vm.organization.profileUrl)?_c('a',{staticClass:"button mb-5",attrs:{"href":_vm.profileUrl,"target":"_blank"}},[_vm._v("\n    View My Profile\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }